// extracted by mini-css-extract-plugin
export var dropdownContainer = "_4q-5";
export var imageContainer = "_4q-4";
export var metricsGrid = "_4q-2";
export var productDetailContainer = "_4q-1";
export var productListContainer = "_4q-0";
export var subscriberTableContainer = "_4q-3";